<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="3">
        <v-text-field v-model="searchQuery.title" label="제목"
                      @keyup.enter="searchPosts"
                      single-line />
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
            label="내용"
            v-model="searchQuery.content"
            @input="searchPosts"
            clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn class="btn" color="primary" @click="searchPosts">Search</v-btn>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn color="primary" @click="createPost">Create</v-btn>
      </v-col>
    </v-row>

<!--    &lt;!&ndash; List of filtered posts &ndash;&gt;-->
<!--    <v-list>-->
<!--      <v-list-item v-for="post in boardList" :key="post.boardId">-->
<!--        <v-list-item-content @click="selectPost(post)">-->
<!--          <v-list-item-title>{{ post.title }}</v-list-item-title>-->
<!--          <v-list-item-subtitle>{{ post.content1 }}</v-list-item-subtitle>-->
<!--          <v-list-item-content>{{ post.content2 }}</v-list-item-content>-->
<!--          <v-list-item-text>{{ post.boardId }}</v-list-item-text>-->
<!--        </v-list-item-content>-->

<!--        <v-list-item-action>-->
<!--          <v-btn icon @click="selectPost(post)">-->
<!--            <v-icon>mdi-modify</v-icon>-->
<!--          </v-btn>-->
<!--        </v-list-item-action>-->
<!--      </v-list-item>-->
<!--    </v-list>-->
<!--      <v-pagination v-model="page" :length="total"-->
<!--                    @input="searchPosts"/>-->
    </v-container>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  components: { },
  props:{
    boardList: Array,
    total: {type: Number, default: 1}
  },
  data() {
    return {
      page: 1,
      searchQuery: {
        content: '',
        title: '',
        page: 0,
        size: 30,
        sort: 'boardId,desc',
      },
      isShowBoard: false,
      selectedRow: {},
    };
  },
  computed: {
    ...mapGetters(['app', 'user', 'isOwner']),
  },
  methods: {
    async searchPosts() {
      this.listLoading = true
      this.$emit('searchPosts', this.searchQuery)
    },

    createPost() {
      this.$emit('createPost')
    },
    selectPost(post){
      this.$emit('selectPost', post)
    },
  },
};
</script>
